import i18n from "../../common/languageHandling/i18n";
import { dataInterval } from "../../common/types";
import { IValues } from "../../nodeDetails/types";

const getShortMonthNames = () => {
  return [
    i18n.t("Jan"),
    i18n.t("Feb"),
    i18n.t("Mars"),
    i18n.t("Apr"),
    i18n.t("May"),
    i18n.t("June"),
    i18n.t("July"),
    i18n.t("Aug"),
    i18n.t("Sep"),
    i18n.t("Oct"),
    i18n.t("Nov"),
    i18n.t("Dec"),
  ];
};
const getShortWeekDays = () => {
  return [
    i18n.t("Mon"),
    i18n.t("Tue"),
    i18n.t("Wed"),
    i18n.t("Thu"),
    i18n.t("Fri"),
    i18n.t("Sat"),
    i18n.t("Sun"),
  ];
};

export const getIntervalType = (period: string) => {
  switch (period) {
    case "Year":
      return dataInterval.Month;

    case "Month":
      return dataInterval.Day;

    case "Week":
      return dataInterval.Day;

    case "Day":
      return dataInterval.Hour;
    default:
      return dataInterval.Day;
  }
};

export const generateLabeldependingOnPeriod = (
  period: string,
  values: IValues[]
) => {
  if (period === "year") {
    return getShortMonthNames();
  }
  if (period === "month") {
    return values.map((_, i) => i + 1);
  }
  if (period === "week") {
    return getShortWeekDays();
  }
  if (period === "days") {
    return values.map((_, i) => i + 1);
  }
  return [];
};
